import "./ProjectHeroMealIdeaGenerator.scss";

function ProjectHeroMealIdeaGenerator() {
  return (
    <>
      <section class="project-cs-hero">
        <div class="project-cs-hero__content">
          <h1 class="heading-primary">Meal Idea Generator</h1>
          <div class="project-cs-hero__info">
            <p class="text-primary text-primary--project">
              This is a website created to suggest dishes based on the type of
              cuisine that you are craving for. Also, it can be used to suggest
              a random dish if you have no specific preference.
            </p>
          </div>
          <div class="project-cs-hero__cta">
            <a
              href="https://supreet-kaur-meal-generator.netlify.app/"
              class="btn btn--bg"
              target="_blank"
              rel="noreferrer"
            >
              Live Link
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

export default ProjectHeroMealIdeaGenerator;
